export default __webpack_public_path__ + "static/media/vitra_chair_02.c1d9757c.jpg";